export enum StatusType {
  INFO = 0,
  SUCCESSFUL = 1,
  ERROR = 2
}
